import { render, staticRenderFns } from "./tabSchedule.vue?vue&type=template&id=081398d4&scoped=true"
import script from "./tabSchedule.vue?vue&type=script&lang=js"
export * from "./tabSchedule.vue?vue&type=script&lang=js"
import style0 from "./tabSchedule.vue?vue&type=style&index=0&id=081398d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081398d4",
  null
  
)

export default component.exports